<!--有休一覧-->
<template>
  <div style="border: 0px solid red; height:100%">
    <el-container style="padding: 0px; width: 100%;height:100%;">
      <!--テーブル-->
      <el-main style="padding: 0px 0px 0px 0px; width: 100%;height: 100%;">
        <!--検索-->
        <div>
          <el-row style="padding-top:5px;padding-left:5px" :gutter="20">
            <!--年-->
            <el-col :span="16">
              <el-date-picker style="width: 110px;" v-model="yearOpt" format="yyyy/MM" @blur="query()" type="month" value-format="yyyy/MM" size="mini" :clearable="false" :editable="false"></el-date-picker>
            </el-col>
            <!--追加 按钮-->
            <el-col :span="6">
              <div>
                <el-button type="primary" id="next_year" style="margin-left:30%" class="css-btn css-button" @click="handleClickNextYear" v-loading.fullscreen.lock="fullscreenLoading" size="mini">{{$t('MODULE.I0015_BTN_ADD')}}</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
        <div style="padding-top: 3px;padding-bottom: 5px;"></div>
        <el-table style="border: 0px solid #AAAAAA" :header-cell-style="i0015HeaderStyle" :cell-style="i0015IsCellStyle" :data="list" border @row-click="i0015RowOnClick" size="mini">
          <!--显示列-->
          <!--申請日-->
          <el-table-column fixed="left" :label="$t('MODULE.I0015_LBL_APPLY_DATE')" min-width="50px" align="center">
            <template slot-scope="scope">
              <div>{{scope.row.jobDate}}</div>
            </template>
          </el-table-column>
          <!--状態-->
          <el-table-column fixed="left" :label="$t('MODULE.I0015_LBL_STATE')" min-width="40px" align="center">
            <template slot-scope="scope">
              <div>{{scope.row.statusName}}</div>
            </template>
          </el-table-column>
          <!--承認者-->
          <el-table-column fixed="left" :label="$t('MODULE.I0015_LBL_ADMINISTRATOR')" align="center">
            <template slot-scope="scope">
              <div>{{scope.row.approvalUser}}</div>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import * as amsApi from "../api/i_0015"
import locale from "element-ui/lib/locale/lang/ja"
import Vue from "vue"
import ElementUI from "element-ui"
import css from "@/statics/css"
let url = require('@/../config/sysConfig')
Vue.use(ElementUI, { locale })
export default {
  mixins: [css],
  data() {
    return {
      userInfo: [],
      cl: '',
      listLoading: false,
      list: [],
      fullscreenLoading: false,
      yearOpt: ''
    };
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    if (!this.yearOpt && !this.$route.query.yearOpt) {
      this.yearOpt = this.timeDefault()
    } else {
      this.yearOpt = this.$route.query.yearOpt
    }
    // 期間より検索
    this.query()
  },
  mounted() {
  },
  methods: {
    //默认作業期間
    timeDefault() {
      var date = new Date();
      var curr_month = date.getMonth() + 1;
      var curr_year = date.getFullYear();
      String(curr_month).length < 2 ? (curr_month = "0" + curr_month) : curr_month;
      var s1 = curr_year + "/" + curr_month;
      return s1;
    },
    query() {
      this.list = []
      //实现Loading 加载方法
      this.set_loading()
      //取得当前用户的用户ID
      var userCd = JSON.parse(localStorage.getItem('userInfo')).userCd
      var yearMonth = this.yearOpt.split('/')[0] + this.yearOpt.split('/')[1]
      //检索条件保存到本地
      sessionStorage.setItem('searchParam', JSON.stringify(yearMonth))
      amsApi.i_0015_search(yearMonth, userCd).then(response => {
        if (response.code === 300) {
          this.$message.warning({ message: this.$t('COMMON.NO_TARGET_DATA'), showClose: true })
          this.list = []
          //关闭loading
          this.close_loading()
          return
        }
        this.list = response.items.holidayInfoSet;
        // doLayout  再加载
        this.table_doLayout()
        //关闭loading
        this.close_loading()
      }).catch((err) => {
        //关闭loading
        this.close_loading()
      });
    },
    // TABLEHeader样式
    i0015HeaderStyle({ row, column, rowIndex, columnIndex }) {
      return 'background-image:linear-gradient(#3cc6fa,#1197ca);color:#FFFFFF;box-shadow:  1px 1px 5px 0px 	rgba(0, 0, 0, 0.48);fontSize:15px;text-align:center '
    },
    // TABLE单元格样式
    i0015IsCellStyle({ row, colum, rowIndex, columnIndex }) {
      return 'text-align:center;fontSize:13px'
    },
    // 单击行事件
    i0015RowOnClick(thisRowDate, column, cell, event) {
      sessionStorage.setItem('I0015Param', JSON.stringify(thisRowDate));
      sessionStorage.setItem('I0016ProcessDiv', JSON.stringify('2'));
      this.$router.push({ path: url.routerUrl_I0016, query: { yearOpt: this.yearOpt } });
    },
    // ログアウト処理
    log_out() {
      this.$message.closeAll();
      var vm = this;
      vm.$router.push({ path: "/login" });
    },
    //追加按钮按下
    handleClickNextYear(e) {
      sessionStorage.setItem('I0016ProcessDiv', JSON.stringify('1'));
      this.$router.push({ path: url.routerUrl_I0016, query: { yearOpt: this.yearOpt } });
    },
  },
}

</script>
<style scope>
</style>


// WEBPACK FOOTER //
// src/module/page/i_0015.vue